module.exports = __webpack_public_path__ + "img/print-white-small-icon.77f390e1.svg";